"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWidgetBrokenAlertsQuery = void 0;
// (C) 2020-2022 GoodData Corporation
var react_1 = require("react");
var model_1 = require("../../../model");
exports.useWidgetBrokenAlertsQuery = function (widget, alert) {
    var dashboardFilters = model_1.useDashboardSelector(model_1.selectFilterContextFilters);
    var _a = model_1.useDashboardQueryProcessing({
        queryCreator: model_1.queryWidgetBrokenAlerts,
    }), runBrokenAlertsQuery = _a.run, result = _a.result, status = _a.status, error = _a.error;
    var effectiveFilters = result;
    react_1.useEffect(function () {
        if (widget.ref) {
            runBrokenAlertsQuery(widget.ref);
        }
        // queryWidgetBrokenAlerts as a parameter it needs just widget.ref but internally result depends on alert, widget, dashboardFilters
        // we have to call query every time when this dependency changed to get fresh results
    }, [alert, widget, dashboardFilters]);
    return {
        result: effectiveFilters,
        status: status,
        error: error,
    };
};
//# sourceMappingURL=useWidgetBrokenAlertsQuery.js.map